import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "../../styles/footer-app-links.css";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Handle section navigation that works from any page
  const handleSectionNavigation = (sectionId, e) => {
    e.preventDefault();

    // If already on homepage, just scroll to the section
    if (location.pathname === "/") {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Navigate to homepage with scroll instruction
      navigate("/", { state: { scrollToSection: sectionId } });
    }
  };

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-bottom">
          {/* <div className="social-icons">
            <a
              href="https://facebook.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://twitter.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaTwitter />
            </a>
            <a
              href="https://linkedin.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaLinkedinIn />
            </a>
            <a
              href="https://github.com"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaGithub />
            </a>
          </div> */}
          <div className="footer-links">
            <Link to="/terms-and-conditions" className="footer-link">Terms & Conditions</Link>
            <Link to="/cancellation-refund" className="footer-link">Cancellation and Refund</Link>
            <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
            <Link to="/contact-us" className="footer-link">Contact Us</Link>
          </div>
          <p className="copyright">
            &copy; {new Date().getFullYear()} Lambdanest Solutions LLP. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
